type degreeOfKinshipOptionsType = {
  value: string;
  label: string;
};

const degreeOfKinshipOptions = (): degreeOfKinshipOptionsType[] => [
  { value: 'not_relative', label: 'Não é parente' },
  { value: 'father_or_mother', label: 'Pai ou mãe' },
  { value: 'uncle_or_aunt', label: 'Tio ou tia' },
  { value: 'grand_father_or_mother', label: 'Avô ou avó' },
  { value: 'other', label: 'Outro' },
];

export default degreeOfKinshipOptions;
